import { LibraryConfig, urlEnv } from 'guso-libangular';

const URL_ENVS = ['TIS', 'VA', 'VACPP', 'PROD'] as const satisfies readonly urlEnv[];

function isUrlEnv(v: string): v is urlEnv {
    return (URL_ENVS as readonly string[]).includes(v);
}

function readUrlEnvFromMeta(): urlEnv {
    const raw = document.querySelector('meta[name="environment"]')?.getAttribute('content') ?? '';
    const normalized = raw.trim().toUpperCase();
    return isUrlEnv(normalized) ? normalized : 'TIS';
}

export const gusoLibConfig: LibraryConfig = {
    gwContexte: 'gw-synthesegusoemployeur/donneesusagerguso',
    utiliseHeaderSimplifie: true,
    features: {
        ff_consentement_employeur: "false",
        ff_connexion_salarie: "false",
    },
    envUrlLibrary: readUrlEnvFromMeta(),
};
